import { AxiosInstance, AxiosResponse } from "axios"

import { ResponseData } from "../common"

interface ReSendOtpResponseData extends ResponseData {
  message: string
}

export interface SendOtpResponse extends AxiosResponse {
  data: ReSendOtpResponseData
}

export function resendMobileOtpAPI(axiosInstance: AxiosInstance) {
  return axiosInstance({
    method: "post",
    url: "/auth/resend-mobile-otp",
  }) as Promise<SendOtpResponse>
}
